/**
 * Check if a value is considered empty
 * Handles null, undefined, empty string, and empty arrays
 */
export var isEmptyValue = function isEmptyValue(value) {
  return value === null || value === undefined || value === "" || Array.isArray(value) && value.length === 0;
};

/**
 * Normalize a value for comparison purposes
 * Empty values (null, undefined, "", []) are normalized to null
 * Other values are returned as-is
 */
export var normalizeValue = function normalizeValue(value) {
  if (value === null || value === undefined || value === "" || Array.isArray(value) && value.length === 0) {
    return null;
  }
  return value;
};

/**
 * Check if a field error is a "should_be_blank" conditional error
 */
export var isShouldBeBlankError = function isShouldBeBlankError(error) {
  var _error$conditional_me;
  return (error === null || error === void 0 ? void 0 : error.type) === "conditional" && (error === null || error === void 0 || (_error$conditional_me = error.conditional_metadata) === null || _error$conditional_me === void 0 ? void 0 : _error$conditional_me.type) === "should_be_blank";
};

/**
 * Check if a field error is a "required" conditional error
 */
export var isConditionalRequiredError = function isConditionalRequiredError(error) {
  var _error$conditional_me2;
  return (error === null || error === void 0 ? void 0 : error.type) === "conditional" && (error === null || error === void 0 || (_error$conditional_me2 = error.conditional_metadata) === null || _error$conditional_me2 === void 0 ? void 0 : _error$conditional_me2.type) === "required";
};

/**
 * Check if a field error is an "optional" conditional error
 */
export var isConditionalOptionalError = function isConditionalOptionalError(error) {
  var _error$conditional_me3;
  return (error === null || error === void 0 ? void 0 : error.type) === "conditional" && (error === null || error === void 0 || (_error$conditional_me3 = error.conditional_metadata) === null || _error$conditional_me3 === void 0 ? void 0 : _error$conditional_me3.type) === "optional";
};

/**
 * Check if two values are equal after normalization
 * Useful for comparing original vs current field values
 */
export var areValuesEqual = function areValuesEqual(value1, value2) {
  return JSON.stringify(normalizeValue(value1)) === JSON.stringify(normalizeValue(value2));
};

/**
 * Check if a value has changed from its original value
 */
export var hasValueChanged = function hasValueChanged(originalValue, currentValue) {
  return !areValuesEqual(originalValue, currentValue);
};